<script>
import Axios from '@plugin/axios.js'
import Layout from '@layouts/main.vue'
import Hero from '@components/ui/hero-jumbotron.vue'
import SearchInput from '@components/ui/search-input.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  page() {
    return {
      title: this.pageTitle,
      meta: this.pageMeta,
    }
  },
  components: {
    Layout,
    Hero,
    SearchInput,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      glossaryData: [],
      AlphabetData: [],
      Alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      selectedAlphabet: {
        ID: '',
        alphabet: '',
      },
      activeSlide: 0,
      paginationSwiper: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        touchRatio: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      isMobile: global.app.isMobile,
      limit: global.app.isMobile ? 5 : 14,

      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      /** for SEO, meta and hero */
      pageTitle: 'Loading...',
      pageDescription: '',
      pageMeta: [],
      firstLoaded: false,
    }
  },
  computed: {
    // change alphabet for pagination
    splitAlphabet: function() {
      // `this` points to the vm instance
      return this.Alphabet.split('')
    },
  },
  async mounted() {
    if (window.location.hash) {
      const params = window.location.hash.substring(1).split('_')
      this.selectedAlphabet.ID = params[1]
      this.selectedAlphabet.alphabet = params[0]
      await this.getGlossary({
        taxonomy: {
          alphabet: this.selectedAlphabet.ID,
        },
      })
    } else {
      await this.getGlossary()
    }
  },
  methods: {
    nextSlide: function() {
      this.activeSlide += 1
      this.$refs.paginationRef.$swiper.slideNext()
    },
    prevSlide: function() {
      this.activeSlide -= 1
      this.$refs.paginationRef.$swiper.slidePrev()
    },
    filter: function(alpha) {
      this.selectedAlphabet.alphabet = alpha
      if (this.AlphabetData !== null) {
        let alphabet
        this.AlphabetData.forEach((data) => {
          if (data.title.toLowerCase() === alpha.toLowerCase()) {
            alphabet = data.ktaksonomi_record_id
          }
        })
        this.selectedAlphabet.ID = alphabet
        this.getGlossary({
          taxonomy: {
            alphabet: alphabet,
          },
        })
        history.pushState(
          {},
          null,
          this.$route.path +
            `#${encodeURIComponent(alpha)}_${encodeURIComponent(alphabet)}`
        )
      }
    },
    getGlossary: async function(param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'glossary',
        simple: true,
        // limit: 12,
        attribute_show: false,
        lang: this.lang,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param, 'taxonomy', false)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      // get the news
      Axios.get(endpoint).then((response) => {
        const data = response.data.data
        // after successfull response, we should then update the menuItems on data() above
        if (response.data) {
          this.glossaryData = data
          if (this.lang === 'en') {
            this.AlphabetData =
              data[0].taksonomi.length !== 0
                ? data[0].taksonomi.alphabet_en.data_option
                : null
          } else {
            this.AlphabetData =
              data[0].taksonomi.length !== 0
                ? data[0].taksonomi.alphabet.data_option
                : null
          }
        }
        /** FOR SEO and META tag */
        let keyInfo
        if (response.data.info[this.lang] !== undefined) {
          keyInfo = response.data.info[this.lang]
        } else {
          keyInfo = response.data.info[this.lang + ' ']
        }
        this.pageTitle = keyInfo[0].trim()
        this.pageDescription = keyInfo[1].trim()
      })
      // if (this.firstLoaded === false) {
      //   await get.then((val) => {
      //     this.firstLoaded = true
      //     if (val && window.location.hash) {
      //       this.selectedAlphabet = window.location.hash.substring(1)
      //       this.filter(this.selectedAlphabet)
      //     }
      //   })
      // }
    },
    /**
     * Search
     */
    search: function(query) {
      this.selectedAlphabet = null
      this.getGlossary({
        keyword: query,
      })
    },
  },
}
</script>

<template>
  <Layout>
    <Hero
      height="25rem"
      :background="require('@assets/images/demo/glossary/Banner_0.jpg')"
    >
      <b-container class="h-100">
        <b-row class="justify-content-center h-100">
          <div class="col-lg-12 text-center align-self-center">
            <h1
              class="text-white"
              :style="{ fontSize: '2.75rem', fontWeight: '700' }"
              >{{ pageTitle }}</h1
            >
            <p
              class="mt-3 mb-4"
              :style="{
                color: '#fff',
                fontSize: '1.2rem',
                fontWeight: '300',
              }"
              >{{ pageDescription }}</p
            >
          </div>
        </b-row>
      </b-container>
    </Hero>

    <div class="container my-5">
      <div class="row">
        <div class="col-12 px-3 px-lg-0">
          <!-- Kalo client minta, idupin lagi v-if nya (hapus) -->
          <SearchInput
            v-if="false"
            :border="true"
            @searchChanged="search"
          ></SearchInput>
        </div>
      </div>
    </div>

    <div class="container" :class="$style.alphabetPagination">
      <div class="row justify-content-center px-0">
        <div class="col-12">
          <nav aria-label="Page Category">
            <Swiper
              ref="paginationRef"
              class="swiper px-0 px-lg-5 mx-0 mx-lg-3"
              :options="paginationSwiper"
            >
              <SwiperSlide
                v-for="(item, index) in Alphabet"
                :key="index"
                class="swiperSlide"
                :class="$style.pagination"
              >
                <li
                  :class="
                    item === selectedAlphabet.alphabet ? $style.active : ''
                  "
                  @click="filter(item)"
                >
                  {{ item }}
                </li>
              </SwiperSlide>
              <div
                v-show="activeSlide < Alphabet.length - limit"
                slot="button-next"
                class="nextButton"
                @click="nextSlide"
              ></div>
              <div
                v-show="activeSlide > 0"
                slot="button-prev"
                class="prevButton"
                @click="prevSlide"
              ></div>
            </Swiper>
          </nav>
        </div>
      </div>
    </div>

    <div class="container" :class="$style.glossary">
      <div class="row justify-content-center">
        <b-col v-if="glossaryData.length < 1" cols="12">
          {{ $t('no data to fetch') }}
        </b-col>
        <b-col cols="lg-10">
          <b-row>
            <div
              v-for="(glossary, index) in glossaryData"
              :key="index"
              class="col-lg-6 col-md-6 col-sm-12 px-3"
            >
              <div :class="$style.glossaryContent">
                <h1>{{ glossary.title }}</h1>
                <div v-cloak v-html-safe="glossary.content"></div>
              </div>
            </div>
          </b-row>
        </b-col>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.glossary {
  margin: 60px auto;
  .glossaryContent {
    h1 {
      font-weight: $medium;
      color: $dark;
    }
    p {
      font-size: 1.25em;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
.alphabetPagination {
  padding: 2rem 1rem;
  background: $color-light;
  border: 2px solid $gray;
  border-radius: 4px;
  .pagination {
    li {
      @extend %typography-xlarge;

      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 50px;
      padding-bottom: 0.25rem;
      margin: 0 auto;
      font-size: 1.25em;
      color: $dark;
      text-align: center;
      cursor: pointer;
      border: none;
      border-radius: 3px;
      &:active,
      &:hover,
      &.active {
        color: white !important;
        background-color: #2980b9 !important;
      }
    }
  }
}
@media only screen and (max-width: $mobile-sm) {
  .glossary {
    margin: 60px auto;
    .glossaryContent {
      h1 {
        font-size: 2em;
      }
      p {
        font-size: 1em;
      }
    }
  }
  .alphabetPagination {
    width: 92%;
    //   .pagination {
    //   li {
    //     @extend %typography-xlarge;

    //   }
    // }
  }
}
</style>

<style lang="scss">
@import '@design';
.swiperSlide {
  width: calc(1 / 15.25 * 100%);
}
.nextButton {
  position: absolute;
  top: 45%;
  right: 0;
  z-index: 1;
  width: 2.75rem;
  height: 2.75rem;
  cursor: pointer;
  background-color: $dark;
  border-radius: 50%;
  transform: translateY(-50%) rotate(180deg);
  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    width: 12px;
    height: 14px;
    margin-right: 5px;
    content: '';
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAABC0lEQVRYR82YvQ3CMBCFXywKKhfswByUDMAW7MMWDEDJHOxAkYoChYcsgWRZDk6c8x1Z4L58985/HQw/kuws6pO8AtiF2qoAJNcAHvFPqwEE3TnbzQHGCn9hmgEMw3Byzh1LGRMHILkC8CwVbmKgpLtZBki+aidqUQtI7gFcpuoWNVCjWwRAqvDsEJK8Adgu0V1loO/7jff+Ll14kgFp3ZMNaBTOGiB5BnBopXvUQG6b1ILoNHX/p4GYyiwDqRrNtvzcjDRAiruh6UqY5MNmL2idj2ILxhYkqXxUAwQw0xNRkg+bM6FEPha1IJcP03tBDGR2M5rbFvEWzB1bNYDP2Nq9DyRja/NCksvHG30rk5LPWDXmAAAAAElFTkSuQmCC')
      no-repeat 0 0;
    background-size: 100%;
    transform: translate(-70%, -50%);
  }
}
.prevButton {
  position: absolute;
  top: 46%;
  left: 0;
  z-index: 1;
  width: 2.75rem;
  height: 2.75rem;
  cursor: pointer;
  background-color: $dark;
  border-radius: 50%;
  transform: translateY(-50%);
  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    width: 12px;
    height: 14px;
    margin-right: 5px;
    content: '';
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAABC0lEQVRYR82YvQ3CMBCFXywKKhfswByUDMAW7MMWDEDJHOxAkYoChYcsgWRZDk6c8x1Z4L58985/HQw/kuws6pO8AtiF2qoAJNcAHvFPqwEE3TnbzQHGCn9hmgEMw3Byzh1LGRMHILkC8CwVbmKgpLtZBki+aidqUQtI7gFcpuoWNVCjWwRAqvDsEJK8Adgu0V1loO/7jff+Ll14kgFp3ZMNaBTOGiB5BnBopXvUQG6b1ILoNHX/p4GYyiwDqRrNtvzcjDRAiruh6UqY5MNmL2idj2ILxhYkqXxUAwQw0xNRkg+bM6FEPha1IJcP03tBDGR2M5rbFvEWzB1bNYDP2Nq9DyRja/NCksvHG30rk5LPWDXmAAAAAElFTkSuQmCC')
      no-repeat 0 0;
    background-size: 100%;
    transform: translate(-70%, -45%);
  }
}
@media only screen and (max-width: $mobile-sm) {
  .swiperSlide {
    width: calc(1 / 7 * 100%);
  }
}
</style>
